// extracted by css-extract-rspack-plugin
export default {"documentView":"DocumentView_documentView__9Ng1y","wrapperRight":"DocumentView_wrapperRight__7jDMb"};